import { GeneralError } from './general.model';

/**
 * Query report
 */
export interface QueryReport {
  [key: string]: any;
}

export interface Error extends GeneralError {
  Message: string;
}

/**
 * Request body
 */
export interface QueryReportRequest {
  ApplicationTableKey: string;
}

/**
 * Models for application data API
 */
export interface ApplicationId {
  applicationKey: string;
}

export interface ApplicationData {
  DbName: string;
  Name: string;
  Tables: Array<Table>;
  Users: Array<User>;
}

export interface Table {
  Key: string;
  Name: string;
  DbName: string | null;
  Fields: Array<Field>;
  Reports: Array<Report>;
}

/**
 * Single field
 */
export interface Field {
  Key: string;
  Name: string;
  DbName: string;
}

/**
 * Single Report
 */
export interface Report {
  Key: string;
  Name: string;
}

/**
 * Single user
 */
export interface User {
  Email: string;
}

/**
 * Dropdown
 */
export interface DropdownId {
  key: string;
}

export interface Dropdown {
  name: string;
  value: string;
}

/**
 * Post data
 */
export interface FormField {
  [key: string]: string | any;
}

/**
 * Post data fields
 */
export interface BodyDataField {
  Name: string;
  Value: string;
  Base64EncodedFile?: string | null;
}

/**
 * Common body for put, post request
 */
export interface CommonDataBody {
  ApplicationTableKey: string;
  ApplicationKey: string;
  fieldsList: Array<BodyDataField>;
}

/**
 * Post data request object
 */
export interface PostDataBody extends CommonDataBody {
  reportKey?: string;
  where?: number | null;
}

/**
 * Put data request body
 */
export interface PutDataBody extends CommonDataBody {
  Where: RecordId;
}

/**
 * DB Field mapping
 */
export interface DBFieldMap {
  [key: string]: string;
}

/**
 * Post data success
 */
export interface PostDataSuccess {
  recordId: number;
  recordData: QueryReport;
}

/**
 * Put data success
 */
export interface PutDataSuccess extends Omit<PostDataSuccess, 'recordId'> {
  fieldsUpdated: Array<string>;
}

/**
 * Delete a row
 */
export interface DeleteObject {
  ApplicationKey?: string;
  ApplicationTableKey: string;
  Where: RecordId;
}

/**
 * Record id
 */
export interface RecordId {
  Rid: number;
}

/**
 * Delete object success model
 */
export interface DeleteObjectSuccess {
  isDeleted: boolean;
  recordId: number;
  type: null;
}

export interface ConditionalQuery {
  ApplicationTableKey: string;
  ConditionGroups: Array<ConditionalGroup>;
}

/**
 * Conditional group
 */
export interface ConditionalGroup {
  Type: string;
  Conditions: Array<Condition>;
}

/**
 * Condition
 */
export interface Condition {
  ConditionField: {
    Id: number;
  };
  OperationType: string;
  Value: number;
}

/**
 * Types of fields request supports
 */
export enum BODY_FIELD_TYPES {
  FILE = 'FILE',
  STRING = 'STRING',
}

/**
 * Generate conditional model
 */
export interface ConditionGenerator {
  id: number;
  value: number;
  type?: string;
  opType?: string;
}

/**
 * Available caches
 */
export enum AvailableCaches {
  QUERY_REPORT = 'QUERY_REPORT',
  CONDITIONAL_QUERY_REPORT = 'CONDITIONAL_QUERY_REPORT',
  DROPDOWN = 'DROPDOWN',
  USER_APPLICATIONS = 'USER_APPLICATIONS',
  COMPANIES = 'COMPANIES',
  APPLICATION_DATA = 'APPLICATION_DATA',
  NAVIGATION = 'NAVIGATION',
  FIELDS = 'FIELDS',
  FIELD_TYPES = 'FIELD_TYPES',
  REPORT = 'REPORT',
  RELATION = 'RELATION',
  APPLICATION_USERS = 'APPLICATION_USERS',
  ROLES = 'ROLES',
  ROLE_DETAIL = 'ROLE_DETAIL',
  PAGES = 'PAGES',
  LAYOUTS = 'LAYOUTS',
  NOTIFICATION_LOGS = 'NOTIFICATION LOGS',
  PROCESS = 'PROCESS',
  THEMES = 'THEMES',
  DASHBOARDS = 'DASHBOARDS',
  SUPERSETDASHBOARDS = 'SUPERSETDASHBOARDS',
  METABASEDASHBOARDS = 'METABASEDASHBOARDS',
  TABLES = 'TABLES',
  ALLTABLES = 'ALLTABLES',
  FORM = 'FORM',
  SUMMARY_FIELDS = 'SUMMARY_FIELDS',
  DATABASE_REPORTS = 'DATABASE_REPORTS',
  SUMMARY_REPORTS = 'SUMMARY_REPORTS',
  IMPORTS = 'IMPORTS',
  PURGES = 'PURGES',
  COPY_APPS = 'COPY_APPS',
  NOTIFICATION = "NOTIFICATION",
  CLIENTS = "CLIENTS",
  TEMPLATES = "TEMPLATES"
}
